export default __webpack_public_path__ + "static/media/logoBlanco.fe72c7a6.png";